import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { partial } from 'lodash';
import BooleanFeedback from './BooleanFeedback';
import feedbackModes from './feedbackModes.json';
import styles from './styles.module.styl';

const positiveFeedbackTitle = 'Glad to hear that! Any way we can improve?';
const negativeFeedbackTitle = 'Sorry to hear that. Tell us what happened';

class FeedbackSection extends Component {
  static propTypes = {
    trackingCode: PropTypes.string.isRequired,
    trackingData: PropTypes.string.isRequired,
    helpful: PropTypes.string,
    useButtons: PropTypes.bool
  }

  static defaultProps = {
    helpful: 'Was this helpful?',
    useButtons: false
  }

  static contextTypes = {
    trackEvent: PropTypes.func.isRequired
  }

  state = {
    feedbackMode: feedbackModes.NONE,
    showFeedbackModal: false,
    message: ''
  }

  handleMessageChange = (e) => {
    this.setState({ message: e.target.value });
  }

  handleBooleanFeedback = (isFeedbackPositive) => {
    const { trackingCode, trackingData } = this.props;

    this.context.trackEvent(`submit:${trackingCode}:feedback-helpful`, {
      trackData: isFeedbackPositive,
      track_data2: trackingData
    });

    this.setState({
      feedbackMode: isFeedbackPositive ? feedbackModes.POSITIVE : feedbackModes.NEGATIVE,
      showFeedbackModal: true
    });

    $(document).on('click', this.hideFeedbackModalOnOuterClick);
  }
  handlePositiveFeedback = partial(this.handleBooleanFeedback, true);
  handleNegativeFeedback = partial(this.handleBooleanFeedback, false);

  handleMessageFeedback = () => {
    const { message, feedbackMode } = this.state;
    const { trackingCode, trackingData } = this.props;
    let comment;

    if (trackingCode === 'quickstarts:code-snippet') {
      comment = `[${trackingCode}:${trackingData}] - ${message}`;
    } else {
      comment = message;
    }

    this.context.trackEvent(`submit:${trackingCode}:feedback-message`, {
      trackData: message,
      track_data2: feedbackMode,
      track_data3: trackingData
    });
    this.setState({
      feedbackMode: feedbackModes.SENT,
      showFeedbackModal: false
    });
    $.post('/docs/submit-feedback', {
      page_title: document.title,
      page_url: window.location.href,
      positive: feedbackMode === feedbackModes.POSITIVE,
      comment
    });
  }

  hideFeedbackModalOnOuterClick = (e) => {
    if (!$(e.target).closest(this.feedbackModal).length) {
      this.setState({ showFeedbackModal: false });
      $(document).off('click', this.hideFeedbackModalOnOuterClick);
    }
  }

  render() {
    const { feedbackMode } = this.state;
    const { helpful, useButtons } = this.props;

    return (
      <div className={styles.feedback}>
        {feedbackMode === feedbackModes.SENT ?
          <span>Thanks for your feedback!</span> :
          <div>
            <span>{helpful}</span>
            <BooleanFeedback
              text="Yes"
              feedbackMode={feedbackModes.POSITIVE}
              currentFeedbackMode={feedbackMode}
              handleClick={this.handlePositiveFeedback}
              useButtons={useButtons}
            />
            <BooleanFeedback
              text="No"
              feedbackMode={feedbackModes.NEGATIVE}
              currentFeedbackMode={feedbackMode}
              handleClick={this.handleNegativeFeedback}
              useButtons={useButtons}
            />
          </div>
        }
        {this.state.showFeedbackModal &&
          <div
            ref={(e) => { this.feedbackModal = e; }}
            className={styles.feedbackModal}
          >
            <div
              className={styles[feedbackMode.toLowerCase()]}
            />
            <span className={styles.feedbackModalTitle}>
              {feedbackMode === feedbackModes.POSITIVE && positiveFeedbackTitle}
              {feedbackMode === feedbackModes.NEGATIVE && negativeFeedbackTitle}
            </span>
            <textarea
              cols="30"
              rows="10"
              value={this.state.message}
              onChange={this.handleMessageChange}
            />
            <button
              className={`${styles.feedbackModalBtn} btn btn-primary btn-md`}
              onClick={this.handleMessageFeedback}
              disabled={!this.state.message}
            >
              Send
            </button>
          </div>
        }
      </div>
    );
  }
}

export default FeedbackSection;
